import React from "react";
import { formatCurrency } from "../helpers/number.helpers";
import { Box, Table, Tbody, Tr, Td, Th, Thead } from "@chakra-ui/react";
import PropTypes from "prop-types";

const CalculationTh = ({ children }) => (
  <Th fontSize={{ base: "xs", lg: "md" }}>{children}</Th>
);
CalculationTh.propTypes = {
  children: PropTypes.node,
};

export const LoanCalculationTable = ({
  payments,
  installmentLabel,
  installmentPaymentLabel,
  interestCostLabel,
  feesLabel,
  amortizationLabel,
  remainingLabel,
  numberOfYearlyPayments,
  monthLabel,
  yearLabel,
  quarterLabel,
  language
}) => { 
  const spaceRemoverDk = language === "dk" ? "" : " ";
  const thousandDelimiterDk = language === "dk" ? "." : " ";
  const langSpecificKRsuffix = language === "dk" ? "." : "";
  const getInstallmentLabel = (_numberOfYearlyPayments) => {
    if (_numberOfYearlyPayments === 12) {
      return monthLabel;
    } else if (_numberOfYearlyPayments === 4) {
      return quarterLabel;
    } else if (_numberOfYearlyPayments === 1) {
      return yearLabel;
    }
  }
  const _installmentLabel = getInstallmentLabel(numberOfYearlyPayments);

  return (
    <Box
      overflowX={{ base: "scroll", lg: "visible" }}
      css={{ "-webkit-overflow-scrolling": "touch" }}
    >
      <Table variant="striped" fontSize={{ base: "xs", lg: "md" }}>
        <Thead>
          <Tr>
            <CalculationTh>{_installmentLabel}</CalculationTh>
            <CalculationTh>{installmentPaymentLabel}</CalculationTh>
            <CalculationTh>{interestCostLabel}</CalculationTh>
            <CalculationTh>{feesLabel}</CalculationTh>
            <CalculationTh>{amortizationLabel}</CalculationTh>
            <CalculationTh>{remainingLabel}</CalculationTh>
          </Tr>
        </Thead>
        <Tbody>
          {payments.map((downPayment, index) =>
            index > 0 ? (
              <Tr>
                <Td>{index}</Td>
                <Td>
                  {formatCurrency(downPayment.payment, spaceRemoverDk)} kr
                  {langSpecificKRsuffix}
                </Td>
                <Td>
                  {formatCurrency(downPayment.interestCost, spaceRemoverDk)} kr
                  {langSpecificKRsuffix}
                </Td>
                <Td>
                  {formatCurrency(downPayment.fees, spaceRemoverDk)} kr
                  {langSpecificKRsuffix}
                </Td>
                <Td>
                  {formatCurrency(downPayment.amortization, spaceRemoverDk)} kr
                  {langSpecificKRsuffix}
                </Td>
                <Td>
                  {formatCurrency(downPayment.remaining, thousandDelimiterDk)} kr
                  {langSpecificKRsuffix}
                </Td>
              </Tr>
            ) : null
          )}
        </Tbody>
      </Table>
    </Box>
  );};

LoanCalculationTable.propTypes = {
  payments: PropTypes.arrayOf({
    calcPayment: PropTypes.number,
    payment: PropTypes.number,
    interestCost: PropTypes.number,
    fees: PropTypes.number,
    amortization: PropTypes.number,
    remaining: PropTypes.number,
  }),
  installmentLabel: PropTypes.string,
  installmentPaymentLabel: PropTypes.string,
  interestCostLabel: PropTypes.string,
  feesLabel: PropTypes.string,
  amortizationLabel: PropTypes.string,
  remainingLabel: PropTypes.string,
  numberSeparator: PropTypes.string,
};
